"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_ui_components_atoms_typography_1 = require("@motorata/base-ui.components.atoms.typography");
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const List = (_a) => {
    var { list, type } = _a, rest = __rest(_a, ["list", "type"]);
    return (react_1.default.createElement(Wrapper, Object.assign({}, rest), list.map((el, index) => (react_1.default.createElement(base_ui_components_atoms_typography_1.Label, { key: index, type: type, icon: "check" }, el)))));
};
exports.default = List;
const Wrapper = styled_components_1.default.div `
  ${base_ui_components_atoms__atoms_1.common};
  
  > * {
    margin-bottom: ${({ theme }) => theme.space.S};
  }

  svg {
    color: ${({ theme }) => theme.color.primary};
  }
`;
//# sourceMappingURL=List.js.map